<div class="d-flex">
  @switch (viewType) {
    @case ('button') {
      <button
        class="btn gradient print icon-download w-100"
        (click)="export()">
        Export
      </button>
    }
    @case ('icon') {
      <button
        class="btn icon-download"
        matTooltip="Export data"
        (click)="export()">
      </button>
    }
    @case ('text') {
      <div
        class="pointer p-10 c-secondary"
        (click)="export()">
        {{label}}
      </div>
    }
  }
</div>
